<template>
  <div class="login-container">
    <form
      class="form-signin"
      @submit.prevent="resetPassword"
    >
        <div class="col-12">
            <img src="../../assets/routa_light_S.png" style="display: block; margin-left: auto; margin-right: auto; width: auto; height: 6em; margin-bottom: 1em" alt="logo">
        </div>
        <h2 class="form-signin-heading">
            Routa Infra
        </h2>
        <div class="input-group mb-2 mt-4">
            <input type="text" class="form-control" :placeholder="$t('login.username')" :aria-label="$t('login.username')" v-model="username">
        </div>
        <button
            type="submit"
            class="btn btn-primary btn-md w-100 col-sm-12"
        >
            {{ $t('login.reset_password') }}
        </button>
        <div class="d-inline-block forgot" @click.stop="$emit('resetPasswordClose')">
            {{ $t('login.back_to_login') }}
        </div>
    </form>
    <div v-if="loading" id="loader" class="spinner"/>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {inject} from 'vue';

export default {
    name: 'ResetPasswordRequest',
    mixins: [restApi],
    data() {
        return {
            username: '',
            loading: false,
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    methods: {
        resetPassword: function () {
            this.loading = true
            this.restFetchParams(this.resetPasswordUrl, {username: this.username}, this.handleResponse)
        },

        handleResponse: function (response) {
            this.loading = false
            if (response && response.status === 200) {
                this.$emit('resetPasswordDone')
            } else {
                this.showAlert(this.$t('login.password_reset_failed'))
            }
        }
    }
}
</script>
<style>
@import "../../styles/login.css";
</style>
